import MUIShoppingCart from '@mui/icons-material/ShoppingCart'

export const ShoppingCartIcon = MUIShoppingCart
